<template>
<div>
<!--  <v-divider></v-divider>-->
  <v-simple-table :height="__TABLE_HEIGHT__">
    <template v-slot:default>
      <thead>
      <tr>
        <th class="text-left">ID</th>
        <!-- <th class="text-left">组织名称</th> -->
        <th class="text-left">姓名</th>
        <th class="text-left">房产名称</th>
        <th class="text-left">费用周期</th>
        <th class="text-left">费用名称</th>
        <th class="text-left">金额(实收)</th>
        <th class="text-left">金额(应收)</th>
        <th class="text-left">已缴金额</th>
        <th class="text-left">状态</th>
        <!-- <th class="text-left">生成日期</th> -->
        <th class="text-left">操作</th>
      </tr>
      </thead>
      <!-- 撤销 -->
      <tbody
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
      <tr class="text1" v-for="(item,index) in desserts" :key="item.id">
        <td><div style="display: flex;"><div style="margin-left: 5px;">{{item.id}}</div></div></td>
        <!-- <td >{{item.company_name}}</td> -->
        <td >{{item.h_name}}<span v-if="!item.h_name">--</span></td>
        <td >
          {{item.h_name_date}}
        </td>
        <td >{{item.startDate}}至{{item.endDate}}</td>
        <td ><span v-if="item.charge_name">{{item.charge_name}}</span><span v-else>{{item.xsc_ChargeName}}</span></td>
        <td >{{item.charge}}</td>
        <td >{{item.chargePay}}</td>
        <td >{{item.PaidChargeSum}}</td>
        <td ><span v-if="item.state==1">待支付</span><span v-if="item.state==2">已付款</span></td>
        <!-- <td >{{item.generate_date}}</td> -->
        <td class="cdj_td">
<!--          <div style="cursor:pointer;" v-if="isPermission(4003001004)">-->
<!--            <div @click="chakan(item)">详情</div>-->
<!--          </div>-->
<!--          <div style="cursor:pointer;" v-if="item.state==1 && isPermission(4003001002)">-->
<!--            <div style="color: #1867c0;margin-left: 5px;" @click="reduction(item)">减免</div>-->
<!--          </div>-->
          <!-- <div style="cursor:pointer;" v-if="isPermission(4003001003)">
            <div  style="color: red;margin-left: 5px;" @click="del( item.id )">删除</div>
          </div> -->
        </td>
      </tr>
      </tbody>
    </template>
  </v-simple-table>
  <v-divider></v-divider>
  <div class="pages" v-if="desserts">
    <Page :total="total" :page-size="page" @on-change="change"  show-total />
  </div>
  <div class="zhanwu" v-else>没有数据</div>

  <Modal
    v-model="modal12"
    ok-text="确定"
    width="500"
    title="查看详情">
    <div v-if="chakana['id']">
      <p>ID：{{chakana['id']}}</p>
      <p>房产ID：{{chakana['house_id']}}</p>
      <p>生成组ID：{{chakana['weiyi']}}</p>
      <p>编号：{{chakana['number']}}</p>
      <p>姓名：{{chakana['h_name']}}</p>
      <p>组织id：{{chakana['company_id']}}</p>
      <p>项目：{{chakana.h_name_date}}</p>
      <p>收费项：<span v-if="chakana.charge_name">{{chakana.charge_name}}</span><span v-else>{{chakana.xsc_ChargeName}}</span></p>
      <p>实收金额：{{chakana['charge']}}</p>
      <p>应收金额：{{chakana['chargePay']}}</p>
      <p>减免金额：{{chakana['discount']}}</p>
      <p>滞纳金额：{{chakana['delaySum']}}</p>
      <p>滞纳天数：{{chakana['delayDays']}}</p>
      <p>减免滞纳金额：{{chakana['delayDiscount']}}</p>
      <p>已缴金额：{{chakana['PaidChargeSum']}}</p>
      <p>状态：<span v-if="chakana.state==1">待支付</span><span v-if="chakana.state==2">已付款</span></p>
      <p v-if="chakana.remark != ''">备注：{{chakana['remark']}}</p>
      <p>生成时间：{{chakana['generate_date']}}</p>
      <p v-if="chakana.ymt1=='' && chakana.explain==''">仪表编号：{{chakana['ybiao']}}</p>
      <p v-if="chakana.ymt1=='' && chakana.explain==''">抄表读数：{{chakana['chaobiaodushu']}}</p>
      <p v-if="chakana.ymt1==''">抄表人或负责人：{{chakana['chaobiaoname']}}</p>
      <p v-if="chakana.explain != ''">收费说明：{{chakana['explain']}}</p>
      <p>计费开始：{{chakana.startDate}}</p>
      <p><span >计费结束：{{chakana.endDate}}</span></p>
      <p v-if="chakana['log_name']!=null">后台付款操作人：{{chakana['log_name']}}</p>
    </div>
  </Modal>
  <!-- 减免 -->
  <Modal
    v-model="reductions"
    ok-text="确定"
    width="500"
    @on-ok="cdj_reduction"
    title="减免(折扣)">
    <div>
      <div>收费金额：{{order.charge}}</div>
      <div>应收金额：{{order.chargePay}}</div>
      <div>已缴金额：{{order.PaidChargeSum}}</div>
      <div>滞纳天数：{{order.delayDays}}</div>
      <div>滞纳金额：{{order.delaySum}}</div>
      <div>减免金额：{{order.discount}}</div>
      <div>减免滞纳金额：{{order.delayDiscount}}</div>
      <RadioGroup v-model="buttonSize" type="button" style="margin-top:10px">
        <Radio label="1">按金额减免</Radio>
        <Radio label="2">按百分比减免</Radio>
      </RadioGroup>
      <div style="margin-top: 10px;">减免金额公式：原总金额 - 减免金额 = 需支付金额</div>
      <div>减免滞纳金公式：原滞纳金总金额 - 减免金额 = 需支付金额</div>
      <br>
      <div>
        减 免 金 额：{{priceCharge}} -
        <input style="width: 50px;border: 1px solid #a2a2a2;text-align: center;" type="text" v-model="charge">
        = {{price}}
        <span v-if="buttonSize == 2" style="margin-left: 20px;"><input style="width: 50px;border: 1px solid #a2a2a2;text-align: center;" type="text" v-model="chargePercentage">%</span>
      </div>
      <div style="margin-top: 3px;">
        减免滞纳金：{{Number(order.delaySum)}} -
        <input style="width: 50px;border: 1px solid #a2a2a2;text-align: center;" type="text" v-model="charges">
        = {{prices}}
        <span v-if="buttonSize == 2" style="margin-left: 20px;"><input style="width: 50px;border: 1px solid #a2a2a2;text-align: center;" type="text" v-model="chargePercentage1">%</span>
      </div>
    </div>
  </Modal>
</div>
</template>

<script>
export default {
  name: "finance-common-table",
  props:{
    customer_id:{
      type:Number,
      default(){
        return 0
      }
    },
    house_id:{
      type:Number,
      default(){
        return 0
      }
    },
    state:{
      type:Number,
      default(){
        return 0
      }
    }
  },
  data () {
    return {
      radio:'',
      chargeitemID:'',
      chargeitem:[],
      chargePercentage:'',
      chargePercentage1:'',
      buttonSize:'1',
      checked:{
        checked0:'',
        checked1:'',
        checked2:'',
        checked3:'',
        checked4:'',
        checked5:'',
        checked6:'',
        checked7:'',
        checked8:'',
        checked9:'',
        checked10:'',
        checked11:'',
      },
      modal12:false,
      loading:false,
      reductions:false,
      datevalue:[],
      options: [
        {
          value: '',
          label: ''
        },],
      options1: [
        {
          id: 1,
          label: '编号'
        },
        {
          id: 2,
          label: '姓名'
        },
        {
          id: 3,
          label: '身份证'
        },
        {
          id: 4,
          label: '房产'
        },
      ],
      value: '',
      value1:'',
      value2:1,
      input1: '',
      desserts: '',
      cs:'',
      total:0,
      page:12,
      search:'',
      anxiu:'保存',
      chakana:[],
      // state:0,
      order:{
        charge:0,
        chargePay:0,
        PaidChargeSum:0,
        discount:0,
        delaySum:0,
        delayDays:0,
        delayDiscount:0,
      },
      charge:0,
      price:0,
      charges:0,
      prices:0,
      priceCharge:0,
      itemOrder:[],
      homeName:'',
      dataPay:[]
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    var t = Date.parse(new Date()) / 1000;//时间戳
    var login = window.localStorage.getItem('login');
    ERP.showLoading()
    this.$Loading.start();
    this.$myhttp.get('admin/getorderList?login='+login,{
      'Content-Type': 'application/json'
    }).then(backdata=>{ // 异步执行成功后
      // this.value1 = backdata.data[0];//开启不查全部
      this.value = backdata.data;
      this.$myhttp.get('admin/CustomerManagement/financeCommonTable?id=1'+'&company='+this.value +'&company1='+this.value2+'&t='+t+"&distinguish=0&house_id="+this.house_id+'&customer_id='+this.customer_id,{
        'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.desserts = backdata.data[0];
        this.total = backdata.data[1];
        this.page = backdata.data[2];
        this.$Loading.finish();
        ERP.hideLoading()
      });
    });
    //加载公司列表和归属列表
    this.$myhttp.get('admin/getcompany',{
      'Content-Type': 'application/json'
    }).then(backdata=>{ // 异步执行成功后
      this.options = backdata.data[0];
    });
    //加载收费大类（费项）
    this.$myhttp.get('admin/common/getChargeitem',{
      'Content-Type': 'application/json'
    }).then(backdata=>{
      this.chargeitem = backdata.data.data;
    });

    //加载收款方式
    this.$myhttp.get('admin/OrderPayment/index',{
      'Content-Type': 'application/json'
    }).then(backdata=>{
      let dataPay = backdata.data.data;
      this.dataPay = dataPay;
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    modals(e){
      if(this.state != e){
        this.state = e;
        this.change(1);
      }
    },
    //获得当前多少页,分页
    change(e){
      ERP.showLoading()
      this.$Loading.start();
      this.$myhttp.get('admin/CustomerManagement/financeCommonTable?id='+ e + '&search='+ this.search +'&company='+this.value +'&company1='+this.value2+"&state="+this.state+"&chargeitemID="+this.chargeitemID+"&homeName="+this.homeName+"&house_id="+this.house_id+'&customer_id='+this.customer_id,{
        'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.desserts = backdata.data[0];
        this.total = backdata.data[1];
        this.page = backdata.data[2];
        this.$Loading.finish();
        ERP.hideLoading()
      });
    },
  },
  watch:{
    charge(){
      var price = Number(this.order.charge) + Number(this.order.discount) - Number(this.order.delaySum) - Number(this.charge) + Number(this.order.delayDiscount);
      this.price = price.toFixed(2);
      if(this.price < 0){
        this.$Message.error('减免金额不合法');
        return false;
      }
    },
    charges(){
      var prices = Number(this.order.delaySum) - Number(this.charges);
      this.prices = prices.toFixed(2);
      if(this.prices < 0){
        this.$Message.error('减免滞纳金额不合法');
        return false;
      }
    },
    //减免是按金额减免还是按百分比减免切换
    buttonSize(){
      this.chargePercentage = '';
      this.chargePercentage1 = '';
      this.reduction(this.itemOrder);
    },
    //减免金额百分比
    chargePercentage(){
      this.charge = Number(this.priceCharge)*(Number(this.chargePercentage)/100);
      this.charge = this.charge.toFixed(2);
    },
    //减免滞纳金百分比
    chargePercentage1(){
      this.charges = Number(this.order.delaySum)*(Number(this.chargePercentage1)/100);
      this.charges = this.charges.toFixed(2);
    },
    house_id(house_id){
      // this.value2=4;
      this.change(1);
    },
    state(){
      this.change(1);
    }
  },

}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/finance/finance-common-table.vue